import * as $ from 'jquery';
import './billboard-carousel.less';
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ResizeService } from '../../page-services/resize-service';


export class BillboardCarouselCommon {

    public static subscribeResize(callback) {
        ResizeService.subscribeStream(callback);
    }

    public static carouselOptions = {
        infinite: true,
        speed: 300,
        dots: true,
        autoPlay: true,
    }

    public static unSlickPreview() {
        $('.page-preview [id^=billboard-carousel-]').each((i, bc) => {
            BillboardCarouselCommon.unSlick($(bc));
        });
        $('.billboard-carousel-component').removeAttr('style');
    }

    private static unSlick(carousel) {
        try {
            carousel.slick('unslick');
        }
        catch (e) { }
    }


    private static createSlick(carousel) {

        // let width = carousel.parent().width();
        // if (width < 1) {
        //     carousel.closest('.billboard-carousel-component').fadeIn();
        //     return;
        // }
        BillboardCarouselCommon.unSlick(carousel);
        carousel.slick(BillboardCarouselCommon.carouselOptions);
        carousel.closest('.billboard-carousel-component').fadeIn();
    }





    public static initSlick(carousel) {
        BillboardCarouselCommon.createSlick(carousel);

        $(document).off('click', '.billboard-slide-link');
        $(document).on('click', '.billboard-slide-link', (ev) => {
            let target = $(ev.target).closest('.billboard-slide-link');
            let parent = target.closest('.editor-parent');
            if (parent.length == 0)
                window.open(target.attr('data-href'), target.attr('data-target'));
        });
    }

    public static equalHeight(carousel) {
        carousel.find('.slick-slide').height(carousel.find('.slick-track').height());
    }

    public static disableSlickDrag() {
        $('*[draggable!=true]', '.slick-track' as any).unbind('dragstart');
    }


}